

export const kickerStyles = {
    color: "#448DA4",
    fontSize: "1rem !important",
    textTransform:"uppercase",
    fontFamily: "\"Gotham Rounded\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif",
  }

export const buttonStyles = {
    // fontSize: "1rem !important",
    // textTransform:"capitalize",
    // fontWeight:"bold",
    // textAlign: "center !important",
    // width: 'auto'
  }

export const titleStylesHero = (fontTheme) => ({
    height: "1.5rem !important",
    paddingTop: "1.5rem",
    zIndex: '9999',
    paddingLeft: ".2em",
    width: "10rem",
    textTransform: "uppercase",
    letterSpacing: '.02rem',
    fontFamily: fontTheme,
    fontWeight: "bold",
    fontSize: ".8em !important",
})

export const largeTitleStyles = (fontTheme) => ({
    fontSize: "1.8em !important",
    marginBottom: ".6em",
    width: "30rem",
    zIndex: '9999',
    height: "3rem",
    fontFamily: fontTheme,
    textTransform:"uppercase",
    letterSpacing: ".05rem",
})

export const titleStyles = {
    fontFamily: "\"Gotham Rounded\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif",
    alignContent: "center",
    fontWeight: "bold",
    fontSize: "1.4em !important",
    margin: 0
  }

export const kickerContainer = {
    marginTop: "1.5em",
    marginLeft: "1.5em"
  }
  
export const subtitleHero = (fontTheme) => ({
    height: "1.4rem",
    zIndex: '9999',
    width: "50rem",
    fontFamily: fontTheme,
    fontSize: "1em !important"
})

export const textBox = {
    width: "20rem",
    height: "20rem",
    border: "2px solid black"
}


export const buttonTitleHeroContainer = {
    alignItems: "start",
    display: "flex",
    width: "15rem",
    marginTop: "1em",
    height: "1.5rem",
}

export const buttonTitleContainer = {
    display: "flex",
    flexDirection: 'row',
    alignItems: "center",
    padding: '1em 1.5em',
    // "div:first-of-type": {
    //     flexGrow: 1,
    // },
  }

export const descriptionStyles = {
    fontFamily: "\"Gotham Rounded\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif",
    fontWeight: "normal",
    fontSize: "0.89em !important",
    padding: '0 1.3em 1em',
    marginBottom: 0
}

export const priceRange = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: '0 1.4em 1em'
  }
  
export const priceRangeStyles = {
    fontFamily: "\"Gotham Rounded\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif",
    fontWeight: "normal",
    fontSize: "1em !important",
    marginBottom: '0'
  }

  export const heroButton = (fontTheme) => ({
    height: "1.3rem !important",
    fontFamily: fontTheme,
    fontWeight: "bold",
    fontSize: ".9em !important",
    width: "12rem",
    letterSpacing: ".02rem",
    zIndex: '9999',
    textTransform: "uppercase",
  })

  export const heroArrow = (themeColor) => ({
    border: 'solid',
    zIndex: '9999',
    borderColor: themeColor,
    borderWidth: '0 .2em .2em 0',
    display: 'inline-block',
    marginTop: '.5em',
    padding: '.3rem',
    transform: "rotate(-45deg) scale(0.7)"
    
  })

  
  export const imageContainer = {
    position: "relative",
    display: "block",
    maxWidth:"70rem",
    maxHeight:"30rem",
    width: "auto",
    height: "auto",
  }

  export const aspectContainer = {
      position: "relative",
      display: "block",
      height: 0,
      paddingBottom: '56.2%',
      width: "auto",
      overflow: 'hidden',

      ".columns--3 &": {
        paddingBottom: '131.7%',
      }
  }

  export const heroOverlay = {
    position: "absolute",
    top: "40%",
    left: "3%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignItems: "baseline",
    height: "6rem"

  }

  export const playButton = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: 'translate(-50%,-50%)',
    backgroundColor: "rgba(255,255,255, 0.65)",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: "50px",
    width: '50px',
    height: '50px',

      span: {
        position: 'relative',
        left: '4px',
        width: 0,
        height: 0,
        borderTop: '10px solid transparent',
        borderBottom: '10px solid transparent',
        borderLeft: '15px solid rgba(0,0,0, 0.75)',
      }
  }